import { Map, Set } from "immutable";
import { LOCATION_CHANGE } from "connected-react-router/immutable";

import { APP_ACTIONS } from "app/app.constants";
import { UserMapper, AppRoleMapper } from "app/app.mappers";

const initialState = Map({
  appFailure: null,
  currentUser: UserMapper.initial(),
  openPanels: Set(),
  appRoles: Map(),
  users: Map(),
});

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_ACTIONS.GET_CURRENT_USER: {
      if (action.error) return state;
      return state.set("currentUser", UserMapper.from(action.payload));
    }

    case APP_ACTIONS.TOGGLE_PANEL: {
      const { panelId } = action;

      return state.update("openPanels", openPanels =>
        openPanels.has(panelId)
          ? openPanels.delete(panelId)
          : openPanels.add(panelId),
      );
    }

    case APP_ACTIONS.REPLACE_PANEL: {
      const { panelId } = action;

      return state.update("openPanels", openPanels =>
        openPanels.has(panelId)
          ? initialState.get("openPanels")
          : Set([panelId]),
      );
    }

    case APP_ACTIONS.GET_ALL_APP_ROLES: {
      if (action.error) return state;

      return state.set(
        "appRoles",
        Map(
          action.payload.map(appRole => [
            appRole.uniqueInternalName.toString(),
            AppRoleMapper.from(appRole),
          ]),
        ),
      );
    }

    case APP_ACTIONS.GET_USERS: {
      if (action.error) return state;

      return state.set(
        "users",
        Map(
          action.payload.map(user => [
            user.userId.toString(),
            UserMapper.from(user),
          ]),
        ),
      );
    }

    case APP_ACTIONS.CREATE_USER_APP_ROLES: {
      if (action.error) return state;

      return state.setIn(
        ["users", action.userId.toString()],
        UserMapper.from(action.payload),
      );
    }

    case APP_ACTIONS.SET_APPLICATION_FAILURE: {
      return state.set("appFailure", action.payload);
    }

    case LOCATION_CHANGE: {
      return state.get("appFailure") ? state.set("appFailure", null) : state;
    }

    default:
      return state;
  }
};
